import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

import { httpGet } from './../../../../helpers';
import Spinner from './../../../common/Spinner';
import {
  createNotifier,
  closeNotifier,
} from '../../../../actions/snackbarActions';
import { Fragment } from 'react';
import { Typography } from '@material-ui/core';
import Link from '@material-ui/core/Link';

// Styles
import passportStyles from '../../../../assets/jss/components/filterableTable/table/passportStyles';
import { xor } from 'lodash';
const useStyles = makeStyles(passportStyles);

const ReferencePassport = ({ lang, createNotifier, closeNotifier, match }) => {
  
  const classes = useStyles();
  const { t } = useTranslation();

  const [data, setData] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);

  const { id } = match.params;

  useEffect(() => {
    
    const fetch = async () => {
      setDataLoading(true);
      var url = `/v2/api/References/CheckReference/${id}`;
      try {
        const data = await httpGet(
          url,
          { },
          { createNotifier, closeNotifier }
        );

        setData(data);

      } catch (ex) {
        
      }
      finally {
        setDataLoading(false);
      }
    };

    fetch();

  }, [createNotifier, closeNotifier]);

  const getSigners = (signers) => {
    return <div className={classes.property}>
      <Typography variant="h5">
        {t('REFERENCE_PASSPORT.SIGNERS')}
      </Typography>
      <table>
        <tr className={classes.signersTableHeadRow}>
          <td>
              { t('COMMON.FULLNAME')}
          </td>
          <td>{ t('COMMON.POSITION')}</td>
          <td>{ t('REFERENCE_PASSPORT.DATE_OF_SIGN')}</td>
        </tr>
        {
          signers.map((x)=> {
              return <tr>
                <td className={classes.signersTableCell}> { x.fullName } </td>
                <td className={classes.signersTableCell}> { x.position } </td>
                <td className={classes.signersTableCell}> {new Date(x.dateOfSigning).toLocaleDateString()} </td>
              </tr>
          })
        }
      </table>
    </div>
  };
      
  return (
    <div>
      {dataLoading ? (
        <Spinner />
      ) : (
        data && (
          <Fragment>
            <Typography variant="h4">
                {t('REFERENCE_PASSPORT.DOCUMENT_INFORMATION')}
            </Typography>
            <div className={classes.property}>
              <Typography variant="h6" className={classes.propertyTitle}>
                { t('COMMON.NUMBER')}
              </Typography>
              <Typography variant="body1" className={classes.propertyBody}>
                {data.numeration}
              </Typography>
            </div>
            <div className={classes.property}>
              <Typography variant="h6" className={classes.propertyTitle}>
                { t('REFERENCE_PASSPORT.DATE')}
              </Typography>
              <Typography variant="body1" className={classes.propertyBody}>
                {new Date(data.dateOfCreation).toLocaleDateString()}
              </Typography>
            </div>
            <div className={classes.property}>
              <Typography variant="h6" className={classes.propertyTitle}>
              {t('REFERENCE_PASSPORT.REFERENCE_TYPE')}
              </Typography>
              <Typography variant="body1" className={classes.propertyBody}>
                {data.referenceType}
              </Typography>
            </div>
            <div className={classes.property}>
              <Typography variant="h6" className={classes.propertyTitle}>
                { t('COMMON.IIN')}
              </Typography>
              <Typography variant="body1" className={classes.propertyBody}>
                {data.iin}
              </Typography>
            </div>
            <div className={classes.property}>
              <Typography variant="h6" className={classes.propertyTitle}>
              { t('COMMON.FULLNAME')}
              </Typography>
              <Typography variant="body1" className={classes.propertyBody}>
                {data.fullName}
              </Typography>
            </div>
            <div className={classes.property}>
              <Typography variant="h6" className={classes.propertyTitle}>
              { t('COMMON.STATUS')}
              </Typography>
              <Typography variant="body1" className={classes.propertyBody}>
                {data.status}
              </Typography>
            </div>
            <div className={classes.property}>
              <Typography variant="h6" className={classes.propertyTitle}>
                { t('COMMON.LINK')}
              </Typography>
              <Link href={data.documentUrl} component="a" target="_blank"> 
                { t('COMMON.DOWNLOAD')}
              </Link>
            </div>
            { 
              data.signers?.length > 0 ? getSigners(data.signers) : null
            }
          </Fragment>
        )
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  lang: state.locale.lang,
});

export default connect(mapStateToProps, { createNotifier, closeNotifier })(
  ReferencePassport
);
